import React from 'react'
import { DatePicker } from 'antd'

const DateColumnFilter = ({
    setSelectedKeys,
    selectedKeys,
    refInput
}) => {

    return (
        <DatePicker
        style={{ width: 200, marginBottom: 10, display: 'block' }}
        value={selectedKeys[0]}
        ref={(node) => {
            refInput.current = node;
        }}
        placeholder="Buscar"
        onChange={(date) => {
            setSelectedKeys(date ? [date] : []);
        }}
        format="DD/MM/YYYY"
        onPressEnter={() => {
            confirm();
        }}
    />
    )
}
export default DateColumnFilter;
